import { defineComponent, openBlock, createElementBlock } from "vue";
const _hoisted_1 = {
  class: "va-spacer",
  "aria-hidden": "true"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "VaSpacer"
  },
  __name: "VaSpacer",
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1);
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaSpacer.css';
//# sourceMappingURL=VaSpacer.vue_vue_type_script_setup_true_lang.js.map
